module.exports = "./img/378a548e2e80ad152eef9d47e5254df9.png";